// TODO v5: consider to make it private
export default function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/utils/setRef.js
// module id = 238
// module chunks = 2